import React from 'react'
import styled from 'styled-components'

export const StyledTd = styled.td`
  position: relative;
`
StyledTd.defaultProps = { role: 'cell' }

export type TdProps = React.ComponentPropsWithoutRef<'td'>

export const Td = React.forwardRef<HTMLTableCellElement, TdProps>(
  (props, ref) => {
    return <StyledTd ref={ref} {...props} role='cell' />
  }
)
